import * as angular from 'angular';

class FooterController {
    public currentYear = new Date().getFullYear();
    public privacyLink = 'https://business.jisp.com/privacy';
    public privacyText = 'Privacy policy';
}

angular.module('app.common').component('appFooter', {
    template: require('./footer.component.html'),
    controller: FooterController,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/layout/footer/footer.component.ts